import { useState, useRef, useEffect } from "react";
import { Link, useNavigate,  } from "react-router-dom";
import Loader from "../Loader";

const Register = () => {

  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem('linkedin-scheduler-token')) {
      navigate('/panel/dashboard')
    }
  }, [])

  const firstNameRef = useRef();
  const lastNameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();

  const defaultValidationState = {
    firstName: { invalid: false, message: 'Please enter first name' },
    lastName: { invalid: false, message: 'Please enter last name' },
    email: { invalid: false, message: 'Please enter email' },
    password: { invalid: false, message: 'Please enter password' },
  };

  const [validateValues, setValidateValues] = useState(defaultValidationState)

  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordFields, setPasswordFields] = useState({
    field: "password", icon: "fa fa-eye",
  });

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {

    setValidateValues(defaultValidationState);
    event.preventDefault();

    const firstName = firstNameRef.current.value;
    const lastName = lastNameRef.current.value;
    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    let isValid = true;

    if(isEmpty(firstName)) {
      setValidateValues((prevState) => {
        return {...prevState, firstName: {...prevState.firstName, invalid: true}}
      });
      isValid = false;
    }
    

    if(isEmpty(lastName)) {
      setValidateValues((prevState) => {
        return {...prevState, lastName: {...prevState.lastName, invalid: true}}
      });
      isValid = false;
    }
    

    if(isEmpty(email)) {
      setValidateValues((prevState) => {
        return {...prevState, email: {...prevState.email, invalid: true}}
      });
      isValid = false;
    }
    

    if(isEmpty(password)) {
      setValidateValues((prevState) => {
        return {...prevState, password: {...prevState.password, invalid: true}}
      });
      isValid = false;
    }

    const formData = {};
    // const formData = new Object();

    
    if(isValid) {
      setIsLoading(true);

      formData.firstName = firstName;
      formData.lastName = lastName;
      formData.email = email;
      formData.password = password;
      Object.freeze(formData);

      console.table(formData);

      try {
        const response = await fetch(process.env.REACT_APP_EXPRESS_URL + '/auth/register', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
  
        if(!response.ok) {
  
          const error = await response.json();
  
          if(response.status === 422) {
  
            console.table(error.errors);
            for (const key of error.errors) {
  
              setValidateValues((prevState) => {
                return {...prevState, [key.path]: {message: [key.msg], invalid: true}}
              });
            }
            
          } else {
            setResponse((prevState) => {
              return {success :false, message: error.message};
            }) 
          }
           
          return;    
        }
        const data = await response.json();
  
        setResponse((prevState) => {
          return {success :true, message: data.message};
        })
  
        setTimeout(() => {
          setResponse(null);
          navigate('/login');
        }, 3000);
      } catch (error) {
        
        setResponse((prevState) => ({
          success: false,
          message: 'Something went wrong. Please try again.',
        }));
      } finally {
        setIsLoading(false); // Disable loader after receiving response (regardless of success or error)
      }
      

    }
  };

  const updatePasswordFieldHandler = (event) => {
    setPasswordFields((prevState) => {
      return {
        field : prevState.field === 'password' ? 'text' : 'password',
        icon : prevState.field === 'password' ? 'fa fa-eye-slash' : 'fa fa-eye'
      }
    })
  }

  const closeAlert = () => setResponse(null);

  return (
    <div className="flex h-screen bg-gray-900">
      {/* Left Image Panel */}
      <div
        className="hidden md:flex w-1/2 bg-cover bg-center"
        // style={{
        //   backgroundImage:
        //     "url('https://images.unsplash.com/photo-1560529870-1efc5a43990f?q=80&w=1374&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
        // }}
        style={{
          backgroundImage:
            "url('/assets/register-bg-image-png.png')",
        }}
      >
        <div className="bg-opacity-50 w-full h-full flex items-center justify-center">
          <h1 className="text-white text-4xl font-bold max-w-md text-center">
            Join us and streamline your LinkedIn content workflow 🚀
          </h1>
        </div>
      </div>

      {/* Right Form Panel */}
      <div className="flex w-full md:w-1/2 items-center justify-center bg-gray-800 p-10">
        <div className="w-full max-w-md space-y-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            {/* <img src="https://img.icons8.com/color/48/000000/linkedin.png" alt="logo" className="h-10 w-10" />
            <span className="text-white text-2xl font-bold">PostPro</span> */}
            <h1 className="text-3xl font-bold text-blue flex items-center gap-2">
              <i class="text-3xl fa fa-paper-plane"></i>
              PostPro
            </h1>
          </div>
          <h2 className="text-3xl font-semibold text-white text-center">Create an Account</h2>
          {isLoading && <Loader />}
          {response && response.success && (
            <div className="bg-green-500 text-white px-4 py-2 rounded relative">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-white"
                onClick={closeAlert}
              >
                ×
              </button>
            </div>
          )}
          {response && !response.success && (
            <div className="bg-red-500 text-white px-4 py-2 rounded relative">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-white"
                onClick={closeAlert}
              >
                ×
              </button>
            </div>
          )}
          <div className="w-full max-w-md space-y-6 relative">
            <form className="flex flex-col gap-3" onSubmit={submitHandler}>
              <div>
                <label className="block text-sm text-white mb-px" htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  placeholder="First Name"
                  className="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500"
                  autoFocus={true}
                  id="firstName"
                  ref={firstNameRef}
                  aria-describedby="firstName-error"
                  aria-invalid="true"
                />
                {validateValues.firstName.invalid && <span id="firstName-error" className="text-rose-400 text-sm mt-1 block">{validateValues.firstName.message}</span>}
              </div>
              <div>
                <label className="block text-sm text-white mb-1" htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  placeholder="Last Name"
                  className="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500"
                  id="lastName"
                  ref={lastNameRef}
                  aria-describedby="lastName-error"
                  aria-invalid="true"
                />
                {validateValues.lastName.invalid && <span className="text-rose-400 text-sm mt-1 block">{validateValues.lastName.message}</span>}
              </div>
              <div>
                <label className="block text-sm text-white mb-1" htmlFor="email">Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  className="w-full px-4 py-2 bg-gray-700 text-white border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500"
                  id="email"
                  ref={emailRef}
                  aria-describedby="email-error"
                  aria-invalid="true"
                />
                {validateValues.email.invalid && <span className="text-rose-400 text-sm mt-1 block">{validateValues.email.message}</span>}
              </div>
              <div className="relative">
                <label className="block text-sm text-white mb-1" htmlFor="password">Password</label>
                <div className="flex items-center bg-gray-700 border border-gray-600 rounded-lg focus-within:ring-2 focus-within:ring-blue-500">
                  <input
                    type={passwordFields.field}
                    placeholder="Password"
                    className="w-full pr-10 px-4 py-2 rounded-lg bg-gray-700 text-white focus:outline-none"
                    id="password"
                    ref={passwordRef}
                    aria-describedby="password-error"
                    aria-invalid="true"
                  />
                  <div className="border-l border-gray-600 px-3 cursor-pointer text-gray-400" onClick={updatePasswordFieldHandler}>
                  {/* <span
                    className="absolute right-3 top-3 text-gray-400 cursor-pointer"
                    onClick={updatePasswordFieldHandler}
                  > */}
                    {/* <i className={`fas ${passwordShown ? "fa-eye" : "fa-eye-slash"}`} /> */}
                    <i className={passwordFields.icon} />
                  </div>
                </div>
                {validateValues.password.invalid && <span className="text-rose-400 text-sm mt-1 block">{validateValues.password.message}</span>}
              </div>
              <button className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition">
                Register
              </button>
            </form>
          </div>
          <p className="text-sm text-blue-400 text-center">
            Already have an account? <Link to="/login" className="underline">Login here</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;
